import {
	Button,
	Dialog as MuiDialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from '@material-ui/core';
import React from 'react';

const Dialog = ({ state = {} }) => {
	const handleDlgClose = (event, reason) => {
		if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
			state.open = false;
		}
	};

	return (
		<MuiDialog open={!!state.open} disableEscapeKeyDown maxWidth="xs" onClose={handleDlgClose}>
			<DialogTitle>{state.title || ''}</DialogTitle>
			<DialogContent>
				<Typography>{state.body || ''}</Typography>
			</DialogContent>
			<DialogActions>
				{state.buttons &&
					state.buttons.map((b) => (
						<Button
							key={b.label}
							onClick={b.onClick}
							variant={b.primary ? 'contained' : 'text'}
							color="primary"
						>
							{b.label}
						</Button>
					))}
			</DialogActions>
		</MuiDialog>
	);
};

export default Dialog;
